class Nav {
  constructor() { this.init(); }

  init() {
    const toggle   = document.querySelector(".js-nav-toggle");
    const nav      = document.querySelector(".js-nav");
    if (!toggle || !nav) return;

    const dropdownItems = Array.from(nav.querySelectorAll(".nav__item--dropdown"));
    const getDropdownButton = (item) =>
      Array.from(item.children).find((child) => child.classList?.contains("nav__link--dropdown"));

    const dropdownButtons = dropdownItems
      .map((item) => getDropdownButton(item))
      .filter(Boolean);

    const closeBranch = (item) => {
      item.classList.remove("is-subopen");
      const button = getDropdownButton(item);
      if (button) button.setAttribute("aria-expanded", "false");
      item.querySelectorAll(".nav__item--dropdown").forEach((child) => {
        if (child === item) return;
        child.classList.remove("is-subopen");
        const childButton = getDropdownButton(child);
        if (childButton) childButton.setAttribute("aria-expanded", "false");
      });
    };

    const resetDropdowns = () => {
      dropdownItems.forEach((item) => closeBranch(item));
    };

    const closeSiblingDropdowns = (item) => {
      const siblings = Array.from(item.parentElement?.children || []).filter(
        (node) => node !== item && node.classList?.contains("nav__item--dropdown"),
      );
      siblings.forEach((sibling) => closeBranch(sibling));
    };

    const setOpen = (open) => {
      nav.classList.toggle("is-open", open);
      toggle.classList.toggle("is-active", open);
      toggle.setAttribute("aria-expanded", String(open));
      document.documentElement.classList.toggle("overflow-hidden", open);
      if (!open) resetDropdowns();
    };

    toggle.addEventListener("click", () => setOpen(!nav.classList.contains("is-open")));

    const isMobile = () => window.innerWidth < 768 || nav.classList.contains("is-open");

    dropdownButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        if (!isMobile()) return;
        e.preventDefault();
        const parent = btn.closest(".nav__item--dropdown");
        const willOpen = parent && !parent.classList.contains("is-subopen");
        if (parent) {
          closeSiblingDropdowns(parent);
          if (willOpen) {
            parent.classList.add("is-subopen");
          } else {
            closeBranch(parent);
          }
        }
        btn.setAttribute("aria-expanded", String(Boolean(willOpen)));
        if (willOpen && !nav.classList.contains("is-open")) setOpen(true);
      });
    });

    document.addEventListener("click", (e) => {
      const within = e.target.closest(".js-nav") || e.target.closest(".js-nav-toggle");
      if (!within && nav.classList.contains("is-open")) setOpen(false);
    });

    const MQ = 768;
    const onResize = () => {
      if (window.innerWidth >= MQ && nav.classList.contains("is-open")) setOpen(false);
      if (window.innerWidth >= MQ) resetDropdowns();
    };
    window.addEventListener("resize", onResize);
  }
}
export default Nav;
